export default {
    state: {
        depotRelated: {},
        inSet:{},
    },
    mutations: {
        setDepotRelated(state, data) {
            state.depotRelated = data
        },
        setInSet(state, data) {
            state.inSet = data
        }
    }
};
